import { EVENT_TARGET } from "./model";
import { PATIENT_TARGET_RESOLVER } from "./event-target-resolver/patient";
import { CARE_NOTE_TARGET_RESOLVER } from "./event-target-resolver/care-note";
import { EventEmitter } from "./EventEmitter";
import { SystemNotification } from "../providers/notificationProvider";

/**
 *
 * @param {any} data incoming data
 */
export const handleNewData = (data) => {
    const response = JSON.parse(data);
    /**
     *
     * Response should the following props
     * - header
     *  - target
     *  - actionType
     * -body
     */
    const {
        body,
        header: { target, action },
    } = response;

    switch (target) {
        case EVENT_TARGET.PATIENT:
            PATIENT_TARGET_RESOLVER(action, body);
            break;
        case EVENT_TARGET.CARE_NOTE:
            CARE_NOTE_TARGET_RESOLVER(action, body);
            EventEmitter.dispatch(EVENT_TARGET.CARE_NOTE, null);
            break;
        case EVENT_TARGET.CARE_PLAN:
            EventEmitter.dispatch(EVENT_TARGET.CARE_PLAN, null);
            break;
        case EVENT_TARGET.TIMETABLE:
            EventEmitter.dispatch(EVENT_TARGET.TIMETABLE, null);
            break;
        case EVENT_TARGET.ATTACHMENT:
            EventEmitter.dispatch(EVENT_TARGET.ATTACHMENT, null);
            break;
        case EVENT_TARGET.LEAVE:
            EventEmitter.dispatch(EVENT_TARGET.LEAVE, null);
            break;
        case EVENT_TARGET.STAFF_ANNUAL_LEAVE:
            EventEmitter.dispatch(EVENT_TARGET.STAFF_ANNUAL_LEAVE, null);
            break;
        case EVENT_TARGET.ACTIVITY:
            EventEmitter.dispatch(EVENT_TARGET.ACTIVITY, null);
            break;
        case EVENT_TARGET.ROTA:
            EventEmitter.dispatch(EVENT_TARGET.ROTA, null);
            break;
        case EVENT_TARGET.STAFF:
            EventEmitter.dispatch(EVENT_TARGET.STAFF, null);
            break;
        case EVENT_TARGET.APPOINTMENT:
            EventEmitter.dispatch(EVENT_TARGET.APPOINTMENT, null);
            break;
        case EVENT_TARGET.Top_Notify:
            EventEmitter.dispatch(EVENT_TARGET.Top_Notify, body);
            SystemNotification(body);
            break;
        case EVENT_TARGET.Clear_Top_Notify:
            EventEmitter.dispatch(EVENT_TARGET.Clear_Top_Notify, null);
            break;

        default:
            console.log("NOTHING COMES HERE!");
            break;
    }
};
